import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import Axios from "../../config/axiosConfig/axios";
import { Api} from "../../config/apiList/api";
import { Row, Col, Table, Input, Button, notification,Pagination } from 'antd';
import './amlak.css'
import { SpinnerDotted } from 'spinners-react';
import EditModal from "./addValidity";
import InsertAmlak from "./insertAmlak";
import DeactiveAmlak from "./deactiveAmlakModal";


function AmlakList() {
    const [amlakList, setAmlakList] = useState("");
    const [step, setStep] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setTotalPage] = useState(0);

    function changeState(newUserList){
        setAmlakList(newUserList)
    }

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    useEffect( () => {
        Axios.get(`${Api}amlak-list-panel?page=${pageNumber}&search=${search}&size=20`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    console.log(data.data.data);
                    setAmlakList(data.data.data);
                    setTotalPage(data.data.total_pages);
                    setStep(1);

                }

            })
            .catch((error) => {
            });
    }, [pageNumber]);


    const searching = () => {
        if (search.length !== 0) {
            Axios.get(`${Api}amlak-list-panel?search=${search}&size=20`)
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {
                        setAmlakList(data.data.data);
                        setTotalPage(data.data.total_pages);
                        setStep(1);

                    }

                })
                .catch((error) => {
                    RedNotification("مشکلی در اتصال به سرور به وجود آمده است‌ !")
                });
        } else {
            RedNotification("برای جستجو ابتدا باید نام کاربر را وارد نمایید")
        }
    }

    const columns = [
        {
            title: 'شناسه',
            dataIndex: "id",

        },
        {
            title: 'کد املاک',
            dataIndex: 'codeAmlak',

        },
        {
            title: 'نام شرکت',
            dataIndex: 'name_sherkat',

        },

        {
            title: "استان",
            dataIndex: "ostan"

        },
        {
            title: 'اعتبار',
            // dataIndex: 'validity',
            render: (e) => {return <p>{e.validity != null && e.validity !== "" ?new Date(e.validity).toLocaleString("fa", { year: "numeric", day: '2-digit', month: '2-digit'}): "..."}

            </p>},

        },

        {
            title: 'فضای تخصیص داده شده (به گیگ)',
            // dataIndex: 'validity',
            dataIndex: "disk"
        },

        {
            title: 'فضای استفاده شده (به گیگ)',
            // dataIndex: 'validity',
            dataIndex: "diskUsage"
        },
        {
            title: 'تغییر وضعیت فعالیت',
            // dataIndex: 'validity',
            render: (e) => {return <DeactiveAmlak id={e.id} isActive={e.isActive} setAmlakList={setAmlakList} pageNumber={pageNumber}/>}

        },

        {
            title: 'عمليات',
            render: (e) => {
                // return  <Mod userId={e.id} codeAmlak={e.codeAmlak} isLogin={e.isLogin} changeUserList={changeState} pageNumber={pageNumber}/>
                return <EditModal codeAmlak={e.codeAmlak} pageNumber={pageNumber} setAmlakList={setAmlakList}/>
            }
        },
    ];


    switch (step) {
        case 0:
            return <Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerDotted size={89} thickness={180} speed={92} color="rgba(0, 0, 0, 0.85)" style={{ marginTop: '100px' }} />
            </Row>

        case 1:
            return (
                amlakList
                    ? <>
                        <Row style={{ background: 'white', marginBottom: '10px' }}>
                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >
                                <Input
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    id="userSerachInput"
                                    placeholder='برای جستجو کد املاک را وارد نمایید...'
                                />
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >
                                <Button onClick={searching} id='userSearchButton'>جستجوی املاک</Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Button type={"primary"} style={{fontFamily: "IranSansBold"}} onClick={() => {
                                    setStep(2);
                                }}>ثبت املاک</Button>
                            </Col>
                        </Row>

                        <Table rowClassName={(record, index) =>{


                            const validity = record.validity;

                            const result = parseInt((new Date(validity).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
                            

                            if (result <= 14){
                                return 'table-row-red'
                            }

                            else if(result <= 30 && result >= 15){
                                return 'table-row-orange'
                            }

                            else{
                                return 'table-row-green'
                            }

                        }

                        } id='amlakTableList' columns={columns} dataSource={amlakList} pagination={false} />
                        <Row style={{width:'100%', justifyContent:'center'}}>
                            <Pagination
                                style={{direction:'ltr',marginTop:"20px"}}
                                current={pageNumber}
                                total={totalPage * 10}
                                pageSize={10}
                                onChange={
                                    (e)=>{
                                        setPageNumber(e)
                                    }
                                } />
                        </Row>

                    </>
                    :
                    <>
                        <p className='orderColumeText' >املاکی در حال حاضر براي نمايش وجود ندارد</p>
                    </>
            )

        case 2:
            return <InsertAmlak setStep={setStep}/>

    }
}
export default AmlakList;

